import React, { FunctionComponent } from 'react';
import { PageView } from '@jg/react-tracking';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { RouteProps, withRouter, RouteComponentProps } from 'react-router';

import JoinStepNavigationContainer from '../JoinStepNaviagtionContainer/JoinStepNaviagtionContainer';
import OneSearchPicker from '../../components/OneSearchPicker/OneSearchPicker';
import Divider from '../../components/Divider/Divider';
import { IAppState } from '../../types/state.d';
import { appActions, appThunk } from '../../actions';
import { getJoinRoutes, JoinRoutes } from '../../selectors/routeSelectors';
import { getCharityId } from '../../selectors/apiSelectors';

export interface IEvent {
  name: string;
  id: number;
  logo?: string;
  type: string;
  score?: number;
  eventdate?: number;
}

type SelectEventPageProps = RouteComponentProps<unknown> & {
  saveEvent: (event: IEvent) => void;
  savedEvent: IEvent | null;
  pushToPage: typeof appThunk.pushToPage;
  joinRoutes: JoinRoutes;
  switchToCreateMode: () => void;
  charityId: number;
};

export const SelectEventPage: FunctionComponent<SelectEventPageProps> = ({
  saveEvent,
  savedEvent,
  pushToPage,
  joinRoutes,
  switchToCreateMode,
  charityId,
}) => {
  const { t } = useTranslation();
  return (
    <PageView
      trackingData={{
        subtype: 'join team',
        event_value: 'select event',
        page_section: 'join team > select event',
      }}
    >
      <Helmet title={t('title.join.selectEvent')} />
      <main
        data-qa="select-event-page"
        className="jg-space-pbxl jg-space-pbml@md"
      >
        <JoinStepNavigationContainer />
        <h1 className="jg-text--center jg-space-mbmd">
          {t('content.selectEvent.heading')}
        </h1>
        <OneSearchPicker
          filterType={`event&charityId=${charityId}`}
          placeholder={t('content.selectEvent.placeholder')}
          label={t('content.selectEvent.placeholder')}
          isLabelHidden
          onSelection={saveEvent}
          selected={savedEvent}
        />
        <Divider className="jg-space-mvml jg-space-mhn">
          {t('global.or')}
        </Divider>
        <p className="jg-text--center">
          <button
            type="button"
            className="jg-text--link jg-cursor-pointer jg-btn--transparent"
            data-qa="create-event-button"
            onClick={switchToCreateMode}
          >
            {t('content.selectEvent.describeYourOwnEvent')}
          </button>
        </p>
        <div className="jg-tc-button-container jg-space-mtlg">
          <button
            type="button"
            disabled={!savedEvent}
            className="jg-btn"
            onClick={() =>
              joinRoutes.nextStep && pushToPage(joinRoutes.nextStep)
            }
            data-qa="select-event-continue"
          >
            {t('global.button.continue')}
          </button>
        </div>
      </main>
    </PageView>
  );
};

const mapStateToProps = (state: IAppState, ownProps: RouteProps) => ({
  savedEvent: state.app.selectedEvent,
  joinRoutes: getJoinRoutes(state, ownProps),
  charityId: getCharityId(state),
});

const mapDispatchToProps = {
  saveEvent: appActions.saveEvent,
  pushToPage: appThunk.pushToPage,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(SelectEventPage),
);
